<template>
    <div class="trajectory">
        <trajectoryMap ref="trajectoryMap" class="map"></trajectoryMap>
        <div class="top-bg">
            <topTitle class="top-title" :title="'移动能源运营监控调度大屏'"></topTitle>
        </div>
        <div class="content">
            <div class="trajectory-left">
                <trajectoryLeft></trajectoryLeft>
            </div>
            <div class="trajectory-right">
                <trajectoryRight @search="init"></trajectoryRight>
            </div>
        </div>
    </div>
</template>


<script>
import topTitle from '../components/topTitle.vue'
import trajectoryLeft from '../carouselItem/trajectoryComponents/left.vue'
import trajectoryRight from '../carouselItem/trajectoryComponents/right.vue'
import trajectoryMap from '../components/mars3d/trajectoryMap.vue'

import { dataInterface } from '@/api/dataInterfaceApi'
export default {
    components: {
        topTitle,
        trajectoryLeft,
        trajectoryRight,
        trajectoryMap
    },
    data() {
        return {
            formLabelAlign: {}
        }
    },
    mounted() {
        // this.$EventBus.$emit('update', '');
    },
    methods: {
        init(data) {
            let _this = this
            _this.formLabelAlign = data
            _this.loading = true
            _this.loadingText = '轨迹绘制中'

            setTimeout(() => {
                _this.loading = false
            }, 1000 * 10);

            // 查询车辆轨迹
            _this.getVehiclePath()
            // 车辆车速与温度
            _this.getAvg()
            // 车辆累积里程
            _this.getDayMileage()
        },
        //日行驶里程监控—车辆行驶轨迹
        getVehiclePath(vin) {
            let { pickerTime, licensePlate } = this.formLabelAlign
            let params = {
                // enCode: "rxslc_VehiclePath", //日行驶里程监控—车辆行驶轨迹
                // "@vin": vin || '',
                // "@startDate": this.pickerVal[0] + " 00:00:00",
                // "@endDate": this.pickerVal[1] + " 23:59:59",
                "enCode": "rxslc_VehiclePath",
                "@startDate": pickerTime[0],
                "@endDate": pickerTime[1],
                "@vin": licensePlate
            }
            dataInterface.dataFaceApi(params)
                .then((res) => {
                    this.$nextTick(() => {
                        console.log("车辆行驶轨迹", res)
                        // debugger
                        if(res && res.length) {
                            this.$refs.trajectoryMap.setMap(res)
                        }
                        // let positions = res.data.map((item) => [item.longitude, item.latitude])
                        // this.addGraphicLayer(this.map, positions,res.data)
                    })
                })
                .catch(() => {})
        },
        // 车辆车速与温度
        getAvg() {
            let { licensePlate, pickerTime } = this.formLabelAlign || {}
            let params = {
                "enCode": "rxslc_Avg",
                "@startDate": pickerTime[0],
                "@endDate": pickerTime[1],
                "@vin": licensePlate
            }
            dataInterface
                .dataFaceApi(params)
                .then((res) => {
                    console.log('rxslc_Avg=========', res)
                    if(!res || !res.length) return
                    // resolve(res[0])
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        // 车辆累积里程
        getDayMileage() {
            let { licensePlate, pickerTime } = this.formLabelAlign || {}
            let params = {
                "enCode": "rxslc_DayMileage",
                "@startDate": pickerTime[0],
                "@endDate": pickerTime[1],
                "@vin": licensePlate
            }
            dataInterface
                .dataFaceApi(params)
                .then((res) => {
                    console.log('rxslc_DayMileage=========', res)
                    if(!res || !res.length) return
                    // resolve(res[0])
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    }
}
</script>

<style lang="scss" scoped>
.trajectory {
    background: #fff;
    height: 100%;
    position: relative;
    .top-bg {
        position: relative;
        &::before {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            content: '';
            background: linear-gradient(#000 100%, #000 0%);
            opacity: .6;
            z-index: 0;
        }
    }
    .map {
        position: absolute !important;
    }
    .top-title {
        position: relative;
    }
    .content {
        position: relative;
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
        .trajectory-left, .trajectory-right {
            width: 560px;
            flex-shrink: 0;
        }
    }
}
</style>